import React from 'react';

import { Link } from 'app/src/utils/routing';
import { currency } from 'app/src/utils/stringHelpers';
import { dateShort } from 'app/src/utils/timeFormatter';

const columns = [
  {
    key: 'id',
    label: 'Line ID',
  },
  {
    key: 'txnId',
    label: 'Txn ID',
    value: ({ entry }) => entry.txn.id,
    content: ({ entry, value }) => (
      <Link to={`/accounting/transactions/${entry.txn.id}`}>{value}</Link>
    ),
  },
  {
    key: 'bankDate',
    label: 'Date',
    sort: 'desc',
    value: ({ entry }) => entry.txn.bankDate,
    content: dateShort,
  },
  {
    key: 'saleDate',
    label: 'Sale Date',
    sort: 'prevent',
    value: ({ entry }) => entry.txn.sale?.saleOn,
    content: dateShort,
  },
  {
    // Derived from the txn's other lines, so a sales-tax line -- which carries
    // no sale_asset of its own -- still reports the sale it belongs to.
    key: 'sale',
    label: 'Sale',
    sort: 'prevent',
    value: ({ entry }) => entry.txn.sale?.name,
  },
  {
    key: 'txnType',
    label: 'Txn Type',
    sort: 'prevent',
    value: ({ entry }) => entry.txn.type,
  },
  {
    key: 'reference',
    label: 'Reference',
    sort: 'prevent',
    value: ({ entry }) => entry.txn.reference,
  },
  {
    key: 'entity',
    label: 'Entity',
    sort: 'prevent',
    value: ({ entry }) => entry.txn.entityName,
  },
  {
    key: 'account',
    label: 'Account',
    sort: 'prevent',
    value: ({ entry }) => entry.account?.name,
  },
  {
    key: 'feeType',
    label: 'Fee Type',
    sort: 'prevent',
    value: ({ entry }) => entry.fee?.type,
  },
  {
    key: 'stockNumber',
    label: 'Stock #',
    sort: 'prevent',
    value: ({ entry }) => entry.asset?.stockNumber,
  },
  {
    key: 'lotNumber',
    label: 'Lot #',
    value: ({ entry }) => entry.saleAsset?.lotNumber,
  },
  {
    key: 'memo',
    label: 'Memo',
    sort: 'prevent',
  },
  {
    key: 'debitLessCredit',
    label: 'Debit',
    cellStyle: ({ textAlign: 'right' }),
    content: ({ value }) => value >= 0 ? currency(value) : '',
  },
  {
    key: 'creditLessDebit',
    label: 'Credit',
    cellStyle: ({ textAlign: 'right' }),
    content: ({ value }) => value > 0 ? currency(value) : '',
  },
  {
    key: 'locationState',
    label: 'Location State',
    sort: 'prevent',
    value: ({ entry }) => (entry.txn.locationStates || []).join(', '),
  },
  {
    key: 'buyerState',
    label: 'Buyer State',
    sort: 'prevent',
    value: ({ entry }) => entry.txn.buyerState,
  },
];

export default columns;
